<div class="report-action-button">
  <div class="report-action-button__image" [appBackgroundImage]="actionButton?.imageUrl">
    <div class="report-action-button__image__tag" [innerHTML]="'ACTION_BUTTON_MODAL.YOUR_CHALLENGE' | translate"></div>
    <div class="report-action-button__image__title" [innerHTML]="actionButton?.title"></div>
    <ion-button class="--white" [innerHTML]="actionButton?.actionText" (click)="handleClick(actionButton)"></ion-button>
  </div>

  <div class="report-action-button__text">
    <div class="report-action-button__text__title" [innerHTML]="actionButton?.title"></div>
    <div class="report-action-button__text__description" [class.--show-more]="showMore" [innerHTML]="actionButton?.message"></div>
    <div
      *ngIf="actionButton?.message?.length > 115"
      class="report-action-button__text__show"
      [innerHTML]="(showMore ? 'BUTTONS.SHOW_LESS' : 'BUTTONS.SHOW_MORE') | translate"
      (click)="toggleShowMore()"
    ></div>
    <ion-button
      class="report-action-button__text__button --success"
      [innerHTML]="actionButton?.actionText"
      (click)="handleClick(actionButton)"
    ></ion-button>
  </div>
</div>
